"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tableHelper_1 = require("./tableHelper");
const odataFilterBuilder_1 = __importDefault(require("./Utilities/odataFilterBuilder"));
const jsonapi_1 = require("./HttpClient/jsonapi");
const jsonapi_serializer_1 = require("jsonapi-serializer");
const case_1 = __importDefault(require("case"));
const change_case_1 = require("change-case");
class MobileServiceTable {
    constructor(tableName, client) {
        this.relationship = undefined;
        this._encryption = false;
        this.tableName = tableName;
        this.queryParams = {};
        this._baseUrl = client.applicationUrl + "/tables";
        this._jsonApiClient = client._jsonApiClient;
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions && encryptionOptions.enforcement.includes("TABLE")) {
            this._encryption = true;
        }
    }
    getTableName() {
        return this.tableName;
    }
    get composeFilter() {
        return odataFilterBuilder_1.default;
    }
    read() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this._baseUrl}/${this.getTableName()}`;
            const { data } = yield this._jsonApiClient.request("GET", url, {
                params: this.queryParams,
                encryption: this._encryption,
            });
            this.queryParams = {};
            const result = (0, jsonapi_1.deserialize)(data, {
                keyForAttribute: "snake_case",
                extras: { total: data.meta.total, meta: data.meta },
            });
            return result;
        });
    }
    lookup(id) {
        return __awaiter(this, void 0, void 0, function* () {
            let relationshipUrl = "";
            if (this.relationship) {
                relationshipUrl = this.relationship;
            }
            const url = `${this._baseUrl}/${this.getTableName()}/${id}${relationshipUrl}`;
            const { data } = yield this._jsonApiClient.request("GET", url, {
                params: this.queryParams,
                encryption: this._encryption,
            });
            this.queryParams = {};
            const result = (0, jsonapi_1.deserialize)(data, { keyForAttribute: "snake_case" });
            this.relationship = undefined;
            return result;
        });
    }
    filter(params) {
        const cleanedParam = params.split("=");
        const uri = cleanedParam[1] || cleanedParam[0];
        this.queryParams.filter = uri;
        return this;
    }
    sort(params) {
        this.queryParams.sort = params;
        return this;
    }
    limit(params) {
        this.queryParams["page[limit]"] = params;
        return this;
    }
    offset(params) {
        this.queryParams["page[offset]"] = params;
        return this;
    }
    fields(params, tableName) {
        const table = tableName || this.tableName;
        this.queryParams[`fields[${table}]`] = params;
        return this;
    }
    include(params) {
        this.queryParams.include = params.join();
        return this;
    }
    relationships(params) {
        this.relationship = `/relationships/${params}`;
        return this;
    }
    insert(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this._baseUrl}/${this.getTableName()}`;
            const attributes = Object.keys(params).map((item) => (0, change_case_1.snakeCase)(item));
            console.log(attributes);
            const data = new jsonapi_serializer_1.Serializer(this.getTableName(), {
                pluralizeType: false,
                attributes,
                keyForAttribute: (data) => data,
                transform: (data) => ObjectFromEntries(Object.entries(data).map((item) => [
                    ["lower", "snake"].includes(case_1.default.of(item[0])) ||
                        item[0].search("__") >= 0
                        ? item[0]
                        : (0, change_case_1.snakeCase)(item[0]),
                    item[1],
                ])),
            }).serialize(params);
            console.log(data);
            const result = yield this._jsonApiClient.request("POST", url, {
                data,
                encryption: this._encryption,
            });
            return (0, jsonapi_1.deserialize)(result.data, { keyForAttribute: "snake_case" });
        });
    }
    update(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let relationshipUrl = "";
            if (this.relationship) {
                relationshipUrl = this.relationship;
            }
            const url = `${this._baseUrl}/${this.getTableName()}/${params.id}${relationshipUrl}`;
            const attributes = Object.keys(params.data).map((item) => (0, change_case_1.snakeCase)(item));
            console.log(attributes);
            const data = new jsonapi_serializer_1.Serializer(this.getTableName(), {
                attributes,
                keyForAttribute: (data) => data,
                transform: (data) => ObjectFromEntries(Object.entries(data).map((item) => [
                    ["lower", "snake"].includes(case_1.default.of(item[0])) ||
                        item[0].search("__") >= 0
                        ? item[0]
                        : (0, change_case_1.snakeCase)(item[0]),
                    item[1],
                ])),
                pluralizeType: false,
            }).serialize(params.data);
            const result = yield this._jsonApiClient.request("PATCH", url, {
                data,
                encryption: this._encryption,
            });
            this.relationship = undefined;
            return (0, jsonapi_1.deserialize)(result.data, { keyForAttribute: "snake_case" });
        });
    }
    del(params) {
        return __awaiter(this, void 0, void 0, function* () {
            let relationshipUrl = "";
            if (this.relationship) {
                relationshipUrl = this.relationship;
            }
            const url = `${this._baseUrl}/${this.getTableName()}/${params.id}${relationshipUrl}`;
            this.relationship = undefined;
            yield this._jsonApiClient.request("DELETE", url, {
                encryption: this._encryption,
            });
            return params.id;
        });
    }
}
(0, tableHelper_1.defineQueryOperators)(MobileServiceTable);
exports.default = MobileServiceTable;
function ObjectFromEntries(iter) {
    const obj = {};
    for (const pair of iter) {
        if (Object(pair) !== pair) {
            throw new TypeError("iterable for fromEntries should yield objects");
        }
        const { "0": key, "1": val } = pair;
        Object.defineProperty(obj, key, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: val,
        });
    }
    return obj;
}
